module.exports = "<div class=hello _v-9eb86824=\"\"> <img class=cover-pic src=" + require("../assets/cover_card.png") + " _v-9eb86824=\"\"> <h1 class=title _v-9eb86824=\"\">信用卡额度测试</h1> <h3 class=subtitle _v-9eb86824=\"\"> 高富帅 or 屌丝？<br _v-9eb86824=\"\"> 1分钟测出你的信用卡额度 </h3> <div class=start-btn @click=goTest _v-9eb86824=\"\">开始测试</div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-9eb86824!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cover.vue
 ** module id = 71
 ** module chunks = 1
 **/